App.SmNotificationContainerComponent = Em.Component.extend
  classNames: ['sm-notification-container']

  notifier: Em.inject.service()
  session:  Em.inject.service()

  notifications: Em.computed.alias 'notifier.queue'